import { useContext } from 'react';
import { toast } from 'react-toastify';
import { Spinner } from '@ds';
import { Form } from '@ui';
import { AuthContext } from '@lp/core/auth';
import { SchedulerSettingsSubmitRow } from '@lp/features/Scheduler/components';
import { CSSchedulerAtHubWeeklySettingsInputsFormType } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/types';
import { CSSchedulerSettingsAtHubInputsForm } from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/components';
import {
  csSchedulerAtHubWeeklySettingsInputsFormSchema,
  getDefaultCSSchedulerAtHubWeeklyInputsValues,
} from '@lp/features/Scheduler/SchedulerClinicalSpecialistsSettings/config';
import {
  useCSSchedulePeriodAtHubWeeklyInputsQuery,
  useCSScheduleRegionsQuery,
  useCSSetSchedulePeriodAtHubWeeklyInputsMutation,
} from '@/queries/resource/schedule';
import { retrieveUnifiedError } from '@/api/utils';
import { SchedulerPermissions } from '@/permissions';

export const CSSchedulerSettingsAtHubInputsTab = () => {
  const { checkPermission } = useContext(AuthContext);
  const { data: atHubWeeklyInputs } = useCSSchedulePeriodAtHubWeeklyInputsQuery();
  const { data: regionList } = useCSScheduleRegionsQuery();
  const { mutateAsync, isPending } = useCSSetSchedulePeriodAtHubWeeklyInputsMutation();

  const hasWritePermissions = checkPermission(SchedulerPermissions.CSSchedulesSettingsInputsWrite);

  const handleSubmit = async (data: CSSchedulerAtHubWeeklySettingsInputsFormType) => {
    try {
      await mutateAsync(data);

      toast.success(`Scheduler At Hub Weekly Requirements updated successfully`);
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  if (!regionList || !atHubWeeklyInputs) {
    return <Spinner />;
  }

  return (
    <Form<CSSchedulerAtHubWeeklySettingsInputsFormType>
      defaultValues={getDefaultCSSchedulerAtHubWeeklyInputsValues(regionList, atHubWeeklyInputs)}
      schema={csSchedulerAtHubWeeklySettingsInputsFormSchema}
      onSubmit={handleSubmit}
    >
      <CSSchedulerSettingsAtHubInputsForm regions={regionList} isReadOnly={!hasWritePermissions} />
      <SchedulerSettingsSubmitRow backPath="/schedule/cs" isLoading={isPending} isReadOnly={!hasWritePermissions} />
    </Form>
  );
};
